import { createSelector } from 'reselect';

import { RootState } from '../types';

export const socketSelector = (state: RootState) => state.socket;

export const socketReconnectSelector = createSelector(
  socketSelector,
  (socket) => socket.reconnect ?? 0
);

export const socketConnectedSelector = createSelector(
  socketSelector,
  (socket) => socket.connected ?? false
);
